(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function initCollectionTabs() {
    const toggleContainers = document.querySelectorAll('.collection-tabs__toggles');
    toggleContainers.forEach((container) => {
      const toggles = container.querySelectorAll('.collection-tabs__toggle');
      const section = container.closest('.section');
      const resourceLists = section.querySelectorAll('.resource-list');
      const buttonContainers = section.querySelectorAll('.product-list__buttons');

      toggles.forEach((toggle, i) => {
        toggle.addEventListener('click', () => {
          toggles.forEach((t, j) => {
            const isSelected = i === j;

            t.dataset.selected = isSelected ? 'true' : 'false';
            t.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            t.setAttribute('tabindex', isSelected ? '0' : '-1');
          });

          resourceLists.forEach((list, j) => {
            list.hidden = i !== j;
          });

          buttonContainers.forEach((buttonContainer) => {
            buttonContainer.querySelectorAll('a').forEach((button, j) => {
              button.hidden = i !== j;
            });
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
